var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalBars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 256H240C213.6 256 192 277.6 192 304V464C192 490.4 213.6 512 240 512H240C266.4 512 288 490.4 288 464V304C288 277.6 266.4 256 240 256ZM80 384H80C53.6 384 32 405.6 32 432V464C32 490.4 53.6 512 80 512H80C106.4 512 128 490.4 128 464V432C128 405.6 106.4 384 80 384ZM400 128H400C373.6 128 352 149.6 352 176V464C352 490.4 373.6 512 400 512H400C426.4 512 448 490.4 448 464V176C448 149.6 426.4 128 400 128ZM560 0H560C533.6 0 512 21.6 512 48V464C512 490.4 533.6 512 560 512H560C586.4 512 608 490.4 608 464V48C608 21.6 586.4 0 560 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalBars);
export default __webpack_public_path__ + "static/media/signal-bars.2b29efad23d066616f542f40be41f9ee.svg";
export { ForwardRef as ReactComponent };